// API base URL - empty in dev (uses proxy), set REACT_APP_API_URL in production
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
